export default {
    template: `
    <div class="search-input f-search">
        <div class="form-group m-0">
            <label for="search-cart-item">${langhelp.cart.search}</label>
            <input type="search" id="search-cart-item" autocomplete="off" v-model="q">
        </div>
        <div class="text-grey" v-show="q">{{count}} ${langhelp.cart.found}</div>
        <div class="show" aria-live="polite">
        <div class="search-list w-m-700">
            <ul role="list" aria-label="Keresési eredmények">
                <li class="pure-g item-aligns-center" v-for="item in result" :key="item.id">
                     <div class="pure-u-1-4">
                         <img class="pure-img" :src="item.image?.src" v-if="item.image?.src">
                        <img class="pure-img" src="" v-else>
                    </div>
                    <div class="pure-u-3-4">
                     <h3 class="m-0 p-0">{{item.product.name}}</h3>
                        <div class="price fw-bold">{{item.product_discount_prices ?? item.product_prices}} {{currency.symbol}}</div>
                        <div class="text-grey">
                            <span>{{item.product.serial}}</span>
                            <span v-for="characteristic in item.characteristics" :key="characteristic.type_id" class="ml-2">{{characteristic.value}}</span>
                        </div>
                        <div class="pure-g justify-content-right">
                            <button type="button" class="btn btn-primary" v-on:click="addToOrder(item)" v-if="item.in_stock">${langhelp.cart.add}</button>
                            <button type="button" class="btn btn-white" disabled v-on:click="addToOrder(item)" v-else>${lang.cart.out_of_stock}</button>
                        </div>
                    </div>

                </li>
            </ul>
        </div>
        </div>
    </div>`,
    data() {
        return {
            currency: null,
            q: null,
            count: 0,
            result: [],
        };
    },
    computed: {
        show() {
            return this.q && this.q.length > 1 && this.count > 0;
        },
    },
    watch: {
      q() {
        this.search();
      },
    },
    methods:{
        search() {
            if(this.q.length < 2){
                this.count =  0;
                this.result = [];
                return;
            }
            fetch("/api/search?is_help_page=1", {
                method: "POST",
                headers: http.headers(),
                body: JSON.stringify({q: this.q}),
            })
                .then((response) => response.json())
                .then((data) => {
                    this.currency = data.currency ?? {};
                    this.result = data.data ?? [];
                    this.count = data.count ?? 0;
                });
        },
        addToOrder(item){
            const rawCharacteristics = item.characteristics ?? item.productCharacteristics ?? [];
            const characteristics = rawCharacteristics.map((characteristic) => ({
                type_id: characteristic.type_id ?? characteristic.characteristics_type_id ?? characteristic.characteristicsType?.id,
                type: characteristic.type ?? characteristic.characteristicsType?.name ?? characteristic.characteristicsType?.type,
                value_id: characteristic.value_id ?? characteristic.characteristics_value_id ?? characteristic.characteristicsValue?.id,
                value: characteristic.value ?? characteristic.val_text ?? characteristic.characteristicsValue?.val_text ?? characteristic.characteristicsValue?.characteristicsValueTranslations?.[0]?.val_text,
            }));

            this.$emit('add-to-cart',{
                 product_variant_id:item.id,
                 selected_variant_id:item.id,
                 product_name:item.product.name,
                 quantity:1,
                 price:item.product_discount_prices ?? item.product_prices,
                 currency:this.currency?.code ?? this.currency?.currency_code ?? this.currency?.symbol,
                 image: item.image?.src,
                 serial:item.product.serial,
                 characteristics,
                 other_variants:item.other_variants ?? [],
            });

            this.q='';
        }
    }
}
